import {
  FilterInterfaceFilter,
  FormattingFilter,
  isReferenceLabelFormatting,
} from '@ardoq/api-types';
import { DEFAULT_LEGACY_REFERENCE_LABEL_FORMATTING_FILTER_ATTRIBUTES } from '../consts';

const isLegacyReferenceLabelFilter = (
  filter: FormattingFilter | FilterInterfaceFilter
): filter is FilterInterfaceFilter =>
  isReferenceLabelFormatting(filter) && !filter.affectsTypeName;

export const getReferenceLabelFilter = (
  formattingFilters: (FormattingFilter | FilterInterfaceFilter)[]
): FilterInterfaceFilter =>
  formattingFilters.find(isLegacyReferenceLabelFilter) ??
  DEFAULT_LEGACY_REFERENCE_LABEL_FORMATTING_FILTER_ATTRIBUTES;
